
const newModel = () => {
    return {
        phuongXaId: null,
        ten: null,
        tinhTpId: null,
        tenTinhTp: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        phuongXaId: null,
        ten: null,
        tinhTpId: null,
        tenTinhTp: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        phuongXaId: item.phuongXaId,
        ten: item.ten,
        tinhTpId: item.tinhTpId,
        tenTinhTp: item.tenTinhTp,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        phuongXaId: item.phuongXaId,
        ten: item.ten,
        tinhTpId: item.tinhTpId,
        tenTinhTp: item.tenTinhTp,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        phuongXaId: null,
        ten: null,
        tinhTpId: null,
        quanHuyenId: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const phuongXaModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


